// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vuex from 'vuex'
import store from './store/index.js';
import moment from 'moment';
import VueWechatTitle from 'vue-wechat-title'
import "swiper/dist/css/swiper.min.css";

let throttleState = true //防抖节流 状态

// 页面自适应
function PageAdaptive() {
  //很取巧的方式，就是按设计稿开发好固定尺寸的页面后，然后根据各种分辨率进行放大缩小。
  //// 优点：不用考虑适配问题，按设计稿进行固定尺寸开发
  var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
  var scale = devicewidth / 1920; // 分母——设计稿的尺寸
  document.body.style.zoom = scale;//放大缩小相应倍数
}

PageAdaptive()//页面自适应

//监听页面尺寸发送变化
window.addEventListener('resize', function (event) {
  //防抖节流
  if (throttleState) {
    throttleState = false
    setTimeout(() => {
      throttleState = true
    }, 500);
    console.log('窗口大小已改变，新的视口大小为：' + window.innerWidth + 'x' + window.innerHeight);
    PageAdaptive()//页面自适应
  }
});


Vue.use(VueWechatTitle)
Vue.prototype.$moment = moment;
Vue.use(Vuex)
Vue.use(less)
Vue.use(ElementUI)
Vue.config.productionTip = false

// axios.defaults.baseURL = process.env.API_ROOT
// Vue.config.silent = true //vue 去掉所有的warn警告方法


// 全局路由守卫
router.beforeEach((to, from, next) => {
  next()
  // store.commit("alterPageName", to.meta.English);
})

// new Vue({
window.vm = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js